import type { RJSFSchema } from "@rjsf/utils";

export const schema: RJSFSchema = {
  type: "object",
  properties: {
    identifier_type: {
      type: "string",
    },
    id: {
      type: "integer",
      readOnly: true,
    },
    description: {
      type: "string",
    },
    rules: {
      type: ["object", "null"],
      properties: {
        type: {
          type: "string",
          default: "string",
          enum: ["string", "integer"],
        },
        allowOnlyOne: {
          type: "boolean",
          default: true,
        },
        doesNotEqualOwnerSlug: {
          type: "boolean",
          default: false,
        },
      },
      required: ["type"],
    },
  },
  allOf: [
    {
      if: {
        properties: {
          rules: {
            properties: {
              type: { const: "string" },
            },
            required: ["type"],
          },
        },
      },
      then: {
        properties: {
          rules: {
            properties: {
              textCase: {
                type: "string",
                default: "lower",
                enum: ["upper", "lower", "none"],
              },
            },
            required: ["type"],
          },
        },
      },
    },
  ],

  required: ["identifier_type"],
};
